export default "__VITE_ASSET__Bj2UUD$H__"